import { ProjectStatus } from "utils/constants/project.constants";
import { TPossibleAssetStatus } from "utils/helpers/getDisplayedStatus";
import { IPagination } from "./pagination.models";

type TNotificationCreatedBy = "workflow" | "asset" | string;

type TNotificationTemplateType = string;

export enum NotificationCTAType {
  Task = "TASK",
  Asset = "ASSET",
  Project = "PROJECT",
  HAQs = "HA_QUESTIONS",
  Content = "CONTENT",
  Milestones = "MILESTONES",
}

export enum NotificationAssetType {
  Document = "DOCUMENT",
  SupportingInformation = "SUPPORTING_INFORMATION",
  Comment = "COMMENT",
  Question = "QUESTION",
  QuestionResponse = "QUESTION_RESPONSE",
  Product = "PRODUCT",
  ProductFamily = "PRODUCT_FAMILY",
  Substance = "SUBSTANCE",
  AssessmentReport = "ASSESSMENT_REPORT",
  ImportedHAQ = "IMPORTED_HAQ",
  HADecisionLetter = "HA_DECISION_LETTER",
  ECTD = "ECTD",
  ApplicantsStrategy = "APPLICANTS_STRATEGY",
  CoverLetter = "COVER_LETTER",
  InspectionReports = "INSPECTION_REPORTS",
  ReferenceDocument = "REFERENCE_DOCUMENT",
  StructuredDocument = "STRUCTURED_DOCUMENT",
  StructuredDocumentChild = "STRUCTURED_DOCUMENT_CHILD",
}

type TNotificationTemplateMetadata = {
  assetId: string;
  ctaType: NotificationCTAType;
  assetName: string;
  assetType: NotificationAssetType;
  projectId: string;
  templateText: string;
  ctaRequiredTags: string;
  taskOwner?: string;
  custom?: string;
  parentAssetId?: string;
  reason?: string;
  numOfDocuments?: string;
  documentNames?: string;
  targetStatus?: ProjectStatus | TPossibleAssetStatus;
  previousStatus?: ProjectStatus | TPossibleAssetStatus;
  currentStatus?: ProjectStatus | TPossibleAssetStatus;
  groupId?: string;
  assetSourceArn?: string;
};

export interface INotification {
  id: string;
  createdBy: TNotificationCreatedBy;
  createdDate: Date | string;
  lastModifiedBy?: string;
  lastModifiedDate?: Date | string;
  version?: number;
  templateType: TNotificationTemplateType;
  userId: string;
  read: boolean;
  metadata: TNotificationTemplateMetadata;
}

type TNotificationMetadataForCreate = {
  custom: string;
};

export type TNotificationForCreate = {
  createdBy: string;
  createdDate: string;
  templateType: string;
  metadata: TNotificationMetadataForCreate;
};

export interface IGetNotificationsForUser extends IPagination {
  content: INotification[];
}
